export const firebaseConfig = {
	apiKey: 'AIzaSyBShN-cRoe_8664B9ldjtvrw8L0EiegdeI',
	authDomain: 'resolvo.me',
	projectId: 'my-new-year-resolutions',
	storageBucket: 'my-new-year-resolutions.firebasestorage.app',
	messagingSenderId: '672599567141',
	appId: '1:672599567141:web:dc570f02b8d09360e748cc',
	measurementId: 'G-8RT9PLTDK3',
};
